module.exports = __webpack_public_path__ + "img/icon-科学平台.a3b2f7f7.png";